import { DataBean } from "../DataBean";

export class FactorsList extends DataBean {

    public async getFactorsList(year: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFactorsList_Number_String_Number_Number", [year, regexStr, page, recordsPerPage]);
    }

}